import { AssetClassType } from "../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { DateFromType } from "../../../Wrap/Constants/Enums/Domain/Transformation/Valuation/DateFromType";
import { PortfolioValuationSummary } from "../../../Wrap/Models/Domains/Valuation/PortfolioValuationSummary";
import { IJsonDate } from "../../../Wrap/System/IJsonDate";
import { AccountMenuClient } from "../../../Wrap/Api/Dashboard/AccountMenu";
import { PortfolioValuationSummaryClient } from "../../../Wrap/Api/Transformation/PortfolioValuationSummary";
import { PerformanceMethod } from "../../../Wrap/Models/Models/Transformation/Performance/PerformanceMethod";
import { ProductsValuationDetailSummary } from "../../../Wrap/Models/Domains/Valuation/ProductsValuationDetailSummary";
import { ProductsValuationDetailSummaryClient } from "../../../Wrap/Api/Transformation/ProductsValuationDetailSummary";
import { ClientAccountClient } from "../../../Wrap/Api/Account/ClientAccount";
import {
    AccountRoleDispatcher,
    ClientAccountDispatcher,
    ProductDetailsDispatcher,
    UserDispatcher,
    TreasuredAssetsDispatcher,
} from "../Stroes/Variable";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PortfolioCashDetail } from "../../../Wrap/Models/Models/PortfolioAnalysis/Cash/PortfolioCashDetail";
import { PortfolioCashDetailClient } from "../../../Wrap/Api/PortfolioAnalysis/Cashes/PortfolioCashDetail";
import { SideMenu } from "../../../Wrap/Constants/Enums/Menu/SideMenu";
import { MenuItem } from "../../../Wrap/Models/Domains/Menu/MenuItem";
import { User } from "../../../Wrap/Models/Models/User/User";
import { UserClient } from "../../../Wrap/Api/User/User";
import { SubAccountTreasuredAssetsClient } from "../../../Wrap/Api/Account/SubAccountTreasuredAssets";
import { PensionSubAccountSettingsClient } from "../../../Wrap/Api/Account/PensionSubAccountSettings";
import { PensionSubAccountSettings } from "../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { CappedArrangementDetails } from "../../../Wrap/Models/Domains/Drawdown/CappedArrangementDetails";
import { CappedArrangementDetailsClient } from "../../../Wrap/Api/Drawdown/CappedArrangementDetails";
import { AccountRolesClient } from "../../../Wrap/Api/Customer/AccountRoles";
import { AccountRestrictionClient } from "../../../Wrap/Api/Account/AccountRestriction";
import { RestrictionTypeEnum } from "../../../Wrap/Constants/Enums/RestrictionTypeEnum";
import { NewProductLinkClient } from "../../../Wrap/Api/Customer/NewProductLink";
import { ClientSearchByAccountClient } from "../../../Wrap/Api/Customer/ClientSearchByAccount";
import { InstructionTreasuredAssetsClient } from "../../../Wrap/Api/Instruction/InstructionTreasuredAssets";
import { CashPaymentClient } from "../../../Wrap/Api/PortfolioAnalysis/Payment/CashPayment";
import { CashPaymentFrequencyQuery } from "../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPaymentTypeQuery } from "../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import {
    BWABankAccountsDisaptcher,
    ConsolidatedAccountDisaptcher,
} from "../Components/Clients/PortfolioDashboard/Store/Variable";
import { UserCookieClient } from "../../../Wrap/Api/PrivacyPolicy/UserCookie";
import { CookiePolicy } from "../../../Wrap/Models/Models/PrivacyPolicy/CookiePolicy";
import { BwaBranchDataReferral } from "../../../Wrap/Models/Domains/BankAccount/BwaBranchDataReferral";
import { ExperianBankAccountValidationClient } from "../../../Wrap/Api/BankAccounts/ExperianBankAccountValidation";
import { BwaBankAccountValidationRequest } from "../../../Wrap/Models/Domains/BankAccount/BwaBankAccountValidationRequest";
import { ExperianMessageType } from "../../../Wrap/Models/Domains/BankAccount/ExperianMessageType";
import { BankAccountCheckRequest } from "../../../Wrap/Models/Domains/BankAccount/BankAccountCheckRequest";
import { ExperianBankWizardRequestClient } from "../../../Wrap/Api/BankAccounts/ExperianBankWizardRequest";
import { BankAccountCombinedResult } from "../../../Wrap/Models/Domains/BankAccount/BankAccountCombinedResult";
import { PortfolioCashDetailsClient } from "../../../Wrap/Api/PortfolioAnalysis/Cashes/PortfolioCashDetails";

export class Action {
    public static getActionMenus(
        sideMenu: SideMenu,
        hierarchyId: string,
        subAccountHierarchyId: string,
        clAccountId: string,
        customerId: number,
        callBack?: (val: Array<MenuItem>) => void
    ): void {
        const client = new AccountMenuClient();
        const promise = client.get(sideMenu, hierarchyId, subAccountHierarchyId, clAccountId, customerId);
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getNewProductLink(customerId: number, callback) {
        const client = new NewProductLinkClient();
        const promise = client.get(customerId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getPortfolioValuationSummary(
        hierarchyId: string,
        assetClassType: AssetClassType,
        performanceMethod: PerformanceMethod,
        asAt: IJsonDate,
        dateFromType: DateFromType,
        callBack?: (val: PortfolioValuationSummary) => void
    ): void {
        assetClassType = AssetClassType.Tier1;
        performanceMethod = PerformanceMethod.Simple;
        dateFromType = 1;

        const client = new PortfolioValuationSummaryClient();
        const promise = client.get(hierarchyId, assetClassType, performanceMethod, asAt, dateFromType);
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getProductsValuationDetailSummary(
        hierarchyId: string,
        assetClassType: AssetClassType,
        asAt: IJsonDate,
        callBack?: (val: ProductsValuationDetailSummary) => void
    ): void {
        assetClassType = AssetClassType.Tier1;

        const client = new ProductsValuationDetailSummaryClient();
        const promise = client.get(hierarchyId, assetClassType, asAt);

        ProductDetailsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
            ProductDetailsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: res,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getUserCookie(callback?: (val: CookiePolicy) => void): void {
        const client = new UserCookieClient();

        client.get().onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static setUserCookie(setting: boolean, callback?: (val: boolean) => void): void {
        const client = new UserCookieClient();

        client.post(setting).onSuccess((result) => {
            if (callback) {
                callback(result);
            }
            window.location.reload();
        });
    }

    public static getClientAccount(hierarchyId: string, callBack?: (val: ClientAccount) => void): void {
        const client = new ClientAccountClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }

            ClientAccountDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {});
    }

    public static getConsolidatedAccount(hierarchyId: string, callBack?: (val: ClientAccount) => void): void {
        const client = new ClientAccountClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }

            ConsolidatedAccountDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {});
    }

    public static ExperianBankAcountCheck(
        request: Array<BankAccountCheckRequest>,
        callBack?: (val: Array<BankAccountCombinedResult>) => void
    ) {
        const client = new ExperianBankWizardRequestClient();
        client.post(request).onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }

            BWABankAccountsDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });
    }

    public static ValidateExperianBankAccount(
        request: BwaBankAccountValidationRequest,
        callBack?: (val: BwaBranchDataReferral) => void
    ) {
        const client = new ExperianBankAccountValidationClient();
        client.post(request).onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static GetBankBranchData(
        instructionId: number,
        wizardSessionId: number,
        messageType: ExperianMessageType,
        callBack?: (val: Array<BwaBranchDataReferral>) => void
    ) {
        const client = new ExperianBankAccountValidationClient();
        client.get(instructionId, wizardSessionId, messageType).onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static isAccountRestrictionActive(
        subaccounthierarchyid: string,
        restrictionType: RestrictionTypeEnum,
        callBack?: (val: boolean) => void
    ) {
        const client = new AccountRestrictionClient();
        const promise = client.get(subaccounthierarchyid, restrictionType);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result.IsActive);
            }
        });

        promise.onError((err) => {});
    }

    public static getUser(callBack?: (val: User) => void): void {
        const client = new UserClient();
        const promise = client.get();

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }

            UserDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {});
    }

    public static getSubAccountTreasuredAssetsProductIds(
        hierarchyId: string,
        callBack?: (val: Array<number>) => void
    ): void {
        const client = new SubAccountTreasuredAssetsClient();
        const promise = client.get(hierarchyId);

        TreasuredAssetsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }

            TreasuredAssetsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {});
    }

    public static getInstructionTreasuredAssetsProductIds(
        instructionId: number,
        callBack?: (val: Array<number>) => void
    ): void {
        const client = new InstructionTreasuredAssetsClient();
        const promise = client.get(instructionId);

        TreasuredAssetsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }

            TreasuredAssetsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {});
    }

    public static setInstructionTreasuredAssetsProductIds(
        instructionId: number,
        treasuredProductIds: Array<number>,
        callBack?: () => void
    ): void {
        const client = new InstructionTreasuredAssetsClient();
        const promise = client.put(instructionId, treasuredProductIds);

        TreasuredAssetsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((result) => {
            if (callBack) {
                callBack();
            }
        });

        promise.onError((err) => {
            throw new Error("Updating treasured assets failed.");
        });
    }

    public static getPortfolioCash(
        hierarchyId: string,
        asAt: IJsonDate,
        callBack?: (val: Array<PortfolioCashDetail>) => void
    ): void {
        const client = new PortfolioCashDetailsClient();
        const promise = client.get([hierarchyId], asAt);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }

    public static getPensionSubAccountSettings(
        hierarchyId: string,
        callBack?: (val: PensionSubAccountSettings) => void
    ): void {
        const client = new PensionSubAccountSettingsClient();
        const promise = client.get(hierarchyId);
        callBack({
            GadReviewEnabled: true,
            CanConvertToFlexi: true,
        });
        // promise.onSuccess((result) => {
        //     if (callBack) {
        //         callBack(result);
        //     }
        // });
        // promise.onError((err) => {});
        // }
    }

    public static getCappedArrangementDetails(
        hierarchyId: string,
        callBack?: (val: Array<CappedArrangementDetails>) => void
    ) {
        const client = new CappedArrangementDetailsClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }

    public static getAccountRoles(hierarchyId: string, callBack?) {
        const client = new AccountRolesClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            AccountRoleDispatcher.dispatch({
                payload: result,
                actionType: ActionType.Success,
            });
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }

    public static searchClientsByAccount(clAccountId: string, callBack) {
        const client = new ClientSearchByAccountClient();
        const promise = client.get(clAccountId);
        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }

    public static getRegularPaymentCashEntry(
        hierarchyId: string,
        type: CashPaymentTypeQuery,
        frequency: CashPaymentFrequencyQuery,
        callback?
    ) {
        const client = new CashPaymentClient();
        const promise = client.get(hierarchyId, type, frequency);

        promise.onSuccess((result) => {
            const _data = [];
            (result || []).forEach((ele) => {
                if (!_data.some((item) => ele.BatchId == item.BatchId)) {
                    _data.push(ele);
                }
            });
            if (callback) {callback(_data);}
        });
    }

    public static getSubAccountTreasuredAssets(hierarchyId: string, callBack?: (val: Array<number>) => void): void {
        const client = new SubAccountTreasuredAssetsClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }
}
